import { Action } from '@ngrx/store';
import { WorkOrderQueryParameters } from '@quorum/models/xs-query';
import {
  Vehicle,
  WorkOrder,
  WorkOrderCase,
  WorkorderDeclinedMpviCode
} from '@quorum/models/xs-resource';

export enum WorkOrdersEntityActionTypes {
  GetWorkOrdersFromServer = '[Fixed Operations] Get Work Orders From Server',
  GetWorkOrdersFromServerError = '[Fixed Operations] Get Work Orders From Server Error',
  GetWorkOrdersFromServerSuccess = '[Fixed Operations] Get Work Orders From Server Success',
  GetWorkOrderFromServer = '[Fixed Operations] Get Work Order From Server',
  GetWorkOrderFromServerError = '[Fixed Operations] Get Work Order From Server Error',
  GetWorkOrderFromServerSuccess = '[Fixed Operations] Get Work Order From Server Success',
  UpdateWorkOrderOnServer = '[Fixed Operations] Update Work Order On Server',
  UpdateWorkOrderOnServerError = '[Fixed Operations] Update Work Order On Server Error',
  UpdateWorkOrderOnServerSuccess = '[Fixed Operations] Update Work Order On Server Success',
  CreateWorkOrderOnServer = '[Fixed Operations] Create Work Order On Server',
  CreateWorkOrderOnServerError = '[Fixed Operations] Create Work Order On Server Error',
  CreateWorkOrderOnServerSuccess = '[Fixed Operations] Create Work Order On Server Success',
  DeleteWorkOrderFromServer = '[Fixed Operations] Delete Work Order From Server',
  DeleteWorkOrderFromServerError = '[Fixed Operations] Delete Work Order From Server Error',
  DeleteWorkOrderFromServerSuccess = '[Fixed Operations] Delete Work Order From Server Success'
}

export class GetWorkOrdersFromServer implements Action {
  readonly type = WorkOrdersEntityActionTypes.GetWorkOrdersFromServer;
  constructor(public payload: WorkOrderQueryParameters) {}
}

export class GetWorkOrdersFromServerError implements Action {
  readonly type = WorkOrdersEntityActionTypes.GetWorkOrdersFromServerError;
  constructor(public payload: { error: any }) {}
}

export class GetWorkOrdersFromServerSuccess implements Action {
  readonly type = WorkOrdersEntityActionTypes.GetWorkOrdersFromServerSuccess;
  constructor(public payload: WorkOrder[]) {}
}

export class GetWorkOrderFromServer implements Action {
  readonly type = WorkOrdersEntityActionTypes.GetWorkOrderFromServer;
  constructor(public payload: { id: number; query: WorkOrderQueryParameters }) {}
}

export class GetWorkOrderFromServerError implements Action {
  readonly type = WorkOrdersEntityActionTypes.GetWorkOrderFromServerError;
  constructor(public payload: { error: any }) {}
}

export class GetWorkOrderFromServerSuccess implements Action {
  readonly type = WorkOrdersEntityActionTypes.GetWorkOrderFromServerSuccess;
  constructor(public payload: { workOrder: WorkOrder }) {}
}

export class UpdateWorkOrderOnServer implements Action {
  readonly type = WorkOrdersEntityActionTypes.UpdateWorkOrderOnServer;
  constructor(public payload: WorkOrder) {}
}

export class UpdateWorkOrderOnServerError implements Action {
  readonly type = WorkOrdersEntityActionTypes.UpdateWorkOrderOnServerError;
  constructor(public payload: { error: any }) {}
}

export class UpdateWorkOrderOnServerSuccess implements Action {
  readonly type = WorkOrdersEntityActionTypes.UpdateWorkOrderOnServerSuccess;
  constructor(public payload: { workOrder: WorkOrder }) {}
}

export class CreateWorkOrderOnServer implements Action {
  readonly type = WorkOrdersEntityActionTypes.CreateWorkOrderOnServer;
  constructor(public payload: { workOrder: WorkOrder; workOrderQueryParams: WorkOrderQueryParameters }) {}
}

export class CreateWorkOrderOnServerError implements Action {
  readonly type = WorkOrdersEntityActionTypes.CreateWorkOrderOnServerError;
  constructor(public payload: { error: any }) {}
}

export class CreateWorkOrderOnServerSuccess implements Action {
  readonly type = WorkOrdersEntityActionTypes.CreateWorkOrderOnServerSuccess;
  constructor(public payload: WorkOrder) {}
}

export class DeleteWorkOrderFromServer implements Action {
  readonly type = WorkOrdersEntityActionTypes.DeleteWorkOrderFromServer;
  constructor(public payload: WorkOrder) {}
}

export class DeleteWorkOrderFromServerError implements Action {
  readonly type = WorkOrdersEntityActionTypes.DeleteWorkOrderFromServerError;
  constructor(public payload: { error: any }) {}
}

export class DeleteWorkOrderFromServerSuccess implements Action {
  readonly type = WorkOrdersEntityActionTypes.DeleteWorkOrderFromServerSuccess;
  constructor(public payload: WorkOrder) {}
}

export type WorkOrdersEntityAction =
  | GetWorkOrdersFromServer
  | GetWorkOrdersFromServerError
  | GetWorkOrdersFromServerSuccess
  | GetWorkOrderFromServer
  | GetWorkOrderFromServerError
  | GetWorkOrderFromServerSuccess
  | UpdateWorkOrderOnServer
  | UpdateWorkOrderOnServerError
  | UpdateWorkOrderOnServerSuccess
  | CreateWorkOrderOnServer
  | CreateWorkOrderOnServerError
  | CreateWorkOrderOnServerSuccess
  | DeleteWorkOrderFromServer
  | DeleteWorkOrderFromServerError
  | DeleteWorkOrderFromServerSuccess;

export const fromWorkOrdersEntityActions = {
  GetWorkOrdersFromServer,
  GetWorkOrdersFromServerError,
  GetWorkOrdersFromServerSuccess,
  GetWorkOrderFromServer,
  GetWorkOrderFromServerError,
  GetWorkOrderFromServerSuccess,
  UpdateWorkOrderOnServer,
  UpdateWorkOrderOnServerError,
  UpdateWorkOrderOnServerSuccess,
  CreateWorkOrderOnServer,
  CreateWorkOrderOnServerError,
  CreateWorkOrderOnServerSuccess,
  DeleteWorkOrderFromServer,
  DeleteWorkOrderFromServerError,
  DeleteWorkOrderFromServerSuccess
};
